import { map } from 'lodash';

import { formatDateForApi } from 'utils/sdk';

export const buildAddGoalBackendPayload = ({
  values,
  studentId,
  selectedStandards,
  isFromStudentList
}) => {
  return {
    student_ids: isFromStudentList ? values.studentIds : [studentId],
    goal_name: values.goalName,
    description: values.description,
    standard_ids: map(selectedStandards, 'id'),
    target_date: values.targetDate ? formatDateForApi(values.targetDate) : null,
    target_accuracy: parseInt(values.accuracy.replace('%', ''), 10)
  };
};
